import type { ReactNode } from 'react';
import { publicLink } from 'src/common/const';
import { useNewUserTask } from 'src/hooks/activities/use-activity';
import { OpenSettingFrom, SettingMenuType } from 'src/views/main/setting-modal/type';
import { useOpenSettingModal } from 'src/views/main/setting-modal/use-open-setting-modal';
import { MessageBoardType } from './type';

export const useMessageInfo = (onCloseModal?: () => void) => {
  const { basicList, advancedList } = useNewUserTask();
  const openSettingModal = useOpenSettingModal();

  const openUpgradeModal = () => {
    openSettingModal({
      defaultMenuType: SettingMenuType.upgrade,
      from: OpenSettingFrom.message_board,
    });
  };

  const openActivityModal = () => {
    openSettingModal({
      defaultMenuType: SettingMenuType.integral,
      from: OpenSettingFrom.message_board,
    });
  };

  let allScore = 0;
  basicList.concat(advancedList).forEach((item) => {
    allScore += item.score ?? 0;
  });

  const list: Record<
    MessageBoardType,
    {
      title: string;
      text: ReactNode;
      buttonText?: string;
      onClick?: () => void;
      buttonClick?: () => void;
      icon: string;
    }
  > = {
    [MessageBoardType.NEW_USER_TASK]: {
      title: '新手任务',
      text: (
        <>
          完成全部任务，继续获得<span className="text-t4-medium">{allScore}</span>积分，升级
          <a
            className="cursor-pointer text-active_color underline px-1"
            onClick={(event) => {
              event.stopPropagation();
              onCloseModal?.();
              openUpgradeModal();
            }}
          >
            专业版
          </a>
          享积分优惠
        </>
      ),
      onClick: openActivityModal,
      icon: '🤩',
    },
    [MessageBoardType.NEW_USER_TASK_COMPLETED_NOT_STUDENT]: {
      title: '完成新手任务',
      text: (
        <>
          累计获得<span className="text-t4-medium">{allScore}</span>积分，升级空间享积分优惠，或
          <a
            className="cursor-pointer text-active_color underline px-1"
            onClick={openActivityModal}
          >
            邀请朋友注册
          </a>
          继续得积分
        </>
      ),
      buttonText: '去升级',
      buttonClick: openUpgradeModal,
      icon: '🥳',
    },
    [MessageBoardType.NEW_USER_TASK_COMPLETED_STUDENT]: {
      title: '完成新手任务',
      text: (
        <>
          累计获得<span className="text-t4-medium">{allScore}</span>积分，升级空间享积分优惠，或
          <a
            className="cursor-pointer text-active_color underline px-1"
            href={publicLink.authentication}
            target="_blank"
          >
            认证教师/学生身份
          </a>
          立享6折
        </>
      ),
      icon: '🥳',
      buttonText: '去升级',
      buttonClick: openUpgradeModal,
    },
    [MessageBoardType.NEW_USER_TASK_COMPLETED_AUTHENTICATION_STUDENT]: {
      title: '完成新手任务',
      text: (
        <>
          累计获得<span className="text-t4-medium">{allScore}</span>积分，升级空间享积分优惠，或
          <a
            className="cursor-pointer text-active_color underline px-1"
            href={publicLink.campusMaster}
            target="_blank"
          >
            邀请同学认证
          </a>
          继续得积分
        </>
      ),
      icon: '🥳',
      buttonText: '去升级',
      buttonClick: openUpgradeModal,
    },
    [MessageBoardType.EDUCATION_AUTHENTICATION]: {
      title: '通过教师/学生认证',
      text: (
        <>
          升级专业版立享6折，或
          <a
            className="cursor-pointer text-active_color underline px-1"
            href={publicLink.campusMaster}
            target="_blank"
          >
            邀请同学认证
          </a>
          团队版同享积分优惠
        </>
      ),
      icon: '👩🏻‍🎓🧑🏻‍🏫',
      buttonText: '去邀请',
      buttonClick: openActivityModal,
    },
  };

  return list;
};
